import { createApp } from 'vue'
import Scorer from './Scorer.vue'

createApp(Scorer).mount('#app')
